/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import {useTranslation, Trans} from 'react-i18next';
import PropTypes from 'prop-types';

import TextLink from 'components/TextLink';
import Alert from 'components/Alert';

const ReplaceButton = ({onClick, children}) => {
	return (
		<TextLink onClick={onClick} as="button">
			{children}
		</TextLink>
	);
};

const DeleteButton = ({onClick, children}) => {
	return (
		<TextLink onClick={onClick} as="button">
			{children}
		</TextLink>
	);
};

const ProcessingAlert = ({isEditMode, fileName, onReplace, onDelete}) => {
	const {t} = useTranslation();

	return (
		<Alert type="fail">
			{isEditMode ? (
				<Trans
					t={t}
					i18nKey="alert_edit_asset_processing_error_replace"
					name={fileName}
				>
					There was an error when processing the file "{fileName}".
					Please{' '}
					{
						<ReplaceButton onClick={onReplace}>
							upload a new file
						</ReplaceButton>
					}
					.
				</Trans>
			) : (
				<Trans
					t={t}
					i18nKey="alert_asset_processing_error_replace_or_delete"
					name={fileName}
				>
					There was an error when processing the file "{fileName}".
					Please{' '}
					{
						<ReplaceButton onClick={onReplace}>
							upload a new file
						</ReplaceButton>
					}
					or
					{
						<DeleteButton onClick={onDelete}>
							delete the asset
						</DeleteButton>
					}
					.
				</Trans>
			)}
		</Alert>
	);
};

export default ProcessingAlert;

ProcessingAlert.propTypes = {
	isEditMode: PropTypes.bool,
	fileName: PropTypes.string,
	onReplace: PropTypes.func,
	onDelete: PropTypes.func,
};
